import { Component, EventEmitter, Input, Output } from '@angular/core'

import { AuthService } from '@app/core/service/auth.service'
import { Preference } from '@app/core/model/user-preferences.interface'
import { ScopeElementsService } from '../services/scope-elements.service'
import { ScopeElementsConfig } from '../models'
import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'

@Component({
  selector: 'scope-third-party-costs',
  templateUrl: './third-party-costs.component.html',
  styleUrls: ['./third-party-costs.component.scss'],
})
export class ThirdPartyCostsComponent {
  @Input() parent: any
  @Input() level: number
  @Input() config: ScopeElementsConfig
  @Input() columns: Preference[]
  @Output() onUpdateTpc = new EventEmitter<ThirdPartyCost>()
  @Output() onReorderTpcs = new EventEmitter<ThirdPartyCost[]>()

  constructor(
    protected authService: AuthService,
    protected scopeElementsService: ScopeElementsService
  ) {}

  updateTpc(tpc: ThirdPartyCost) {
    this.onUpdateTpc.emit(tpc)
  }

  onOrderChange(orderedTpcs: any[]) {
    const tpcs = orderedTpcs.map((item) => item.entity || item)
    this.onReorderTpcs.emit(tpcs)
  }
}
